(function () {
  if (!document.getElementById("cfh-wrapper")) return;

  const tpl = document.getElementById("cfh-wrapper");
  const frag = tpl.content.cloneNode(true);

  // --- CONFIGURE DELAYS HERE ---
  const CRITICAL_DELAY = 0;   // milliseconds, 0 for immediate
  const NON_CRITICAL_DELAY = 3500; // milliseconds, 10 seconds

  const CRITICAL_MATCH = [
    "shopify",
    "checkout",
    "portable-wallets",
    "captcha",
    "__st",
    "paymentbutton",
    "google-site-verification",
    "shopifycloud"
  ];

  const DELAY_MATCH = [
    "lifteragecheck",
    "supergiftoptions",
    "preview-bar",
    "privacy-banner",
    "shop-js"
  ];

  const critical = [];
  const delayed = [];

  [...frag.childNodes].forEach(node => {
    if (node.nodeType !== 1) return;

    const html = node.outerHTML?.toLowerCase() || "";

    if (CRITICAL_MATCH.some(k => html.includes(k))) {
      critical.push(node);
      return;
    }

    if (DELAY_MATCH.some(k => html.includes(k))) {
      delayed.push(node);
      return;
    }

    // default → critical (Shopify future proof)
    critical.push(node);
  });

  // --- inject critical scripts ---
  const injectCritical = () => critical.forEach(n => document.head.appendChild(n));

  if (CRITICAL_DELAY > 0) {
    setTimeout(injectCritical, CRITICAL_DELAY);
  } else {
    injectCritical();
  }

  // --- inject delayed scripts ---
  const injectDelayed = () => delayed.forEach(n => document.head.appendChild(n));

  if ("requestIdleCallback" in window) {
    requestIdleCallback(() => setTimeout(injectDelayed, NON_CRITICAL_DELAY), { timeout: 15000 });
  } else {
    setTimeout(injectDelayed, NON_CRITICAL_DELAY);
  }
})();
